import React from "react";
import { MAROON } from "./brandColors";

// House-style section card: thin maroon-tinted border, a small maroon leading
// icon next to the title, and an optional right-hand slot for a badge or an
// action button.
//
// This is the React equivalent of the confirmed Flutter card language
// (feedback_flutter_ui_beautification_pattern): a bordered container with an
// icon-bearing section header rather than a plain Bootstrap card with an
// <h6> in it. Kept here in components/common rather than inside one feature
// so every screen that adopts the style stays visually identical for free.
const SectionCard = ({ icon: Icon, title, right, children, className = "", bodyClassName = "" }) => (
  <div
    className={`card mb-3 ${className}`}
    style={{ border: `1px solid ${MAROON}2E`, borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}
  >
    <div className={`card-body ${bodyClassName}`}>
      {(title || right) && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            {Icon && <Icon size={18} style={{ color: MAROON }} className="me-2 flex-shrink-0" />}
            <h6 className="mb-0 fw-bold">{title}</h6>
          </div>
          {right}
        </div>
      )}
      {children}
    </div>
  </div>
);

export default SectionCard;
